/*
 * Copyright (c) 2025.  Chad and contributors.
 * All rights reserved.
 */

import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';


const loadBaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');
const loadBaseAppStore = () => import('@/views/dashboard/appStore/AppStoreBase.vue');
const AppStoreAppConfig = () => import('@/views/dashboard/appStore/AppStoreAppConfig.vue');
const AppStoreAppDetails = () => import('@/views/dashboard/appStore/AppStoreAppDetails.vue');
const AppStoreAppSettings = () => import('@/views/dashboard/appStore/AppStoreAppSettings.vue');


const appStoreRoutes: RouteRecordRaw[] = [
    {
        path: '/app-store',
        component: loadBaseDashboard,
        meta: {
            title: 'app store',
            icon: 'mdi-puzzle',
            noCache: false,
            isBase: true,
            permissions: ['customers_view'],
            showInMenu: true,
            middleware: ['auth'],
            layout: 'Dashboard',
        } as CommonRouteMeta,
        children: [
            {
                path: '',
                component: loadBaseAppStore,
                name: 'app-store.index',
                meta: {
                    title: 'app store',
                    icon: 'mdi-car-convertible',
                    noCache: false,
                    isBase: true,
                } as CommonRouteMeta,
            },
            {
                path: ':id',
                component: AppStoreAppDetails,
                name: 'app-store.details',
                meta: {
                    title: 'app store',
                    noCache: false,
                    isBase: true,
                } as CommonRouteMeta,
            },
            {
                path: ':id/config',
                component: AppStoreAppConfig,
                name: 'app-store.config',
                meta: {
                    title: 'app store',
                    noCache: false,
                    isBase: true,
                } as CommonRouteMeta,
            },
            {
                path: ':id/settings',
                component: AppStoreAppSettings,
                name: 'app-store.settings',
                meta: {
                    noCache: false,
                    isBase: true,
                } as CommonRouteMeta,
            },
        ],
    }
];

export default appStoreRoutes;
